<script lang="ts">
  import { onMount } from "svelte";
  import { resetAllMarkers, setupMap, updateMap, updateMapWithProgressMarkers } from "../lib/helpers/map";
  import type { LatLngLiteral } from "../types/map";

  import maplibregl from "maplibre-gl";
  export let markerCoordinates: LatLngLiteral | undefined = undefined;
  export let mapOverlayCopy: string | undefined = "";
  export let progressLocations: { icon: string; coords: LatLngLiteral }[] = [];

  let container: HTMLDivElement;
  let map: maplibregl.Map;
  let mapLoaded = false;
  export let isMobile = false;

  onMount(() => {
    const options: Partial<maplibregl.MapOptions> = {};
    options.interactive = isMobile;
    if (markerCoordinates) {
      options.center = [markerCoordinates.lng, markerCoordinates.lat];
    }
    map = setupMap(container, options);
    map.on("load", () => {
      mapLoaded = true;
    });
  });

  $: if (mapLoaded && (markerCoordinates || progressLocations?.length > 0)) {
    void (async () => {
      if (markerCoordinates) {
        await updateMap(map, markerCoordinates);
      } else if (progressLocations.length > 0) {
        await updateMapWithProgressMarkers(map, progressLocations, isMobile);
      }
    })();
  } else if (mapLoaded) {
    resetAllMarkers(map);
  }
  $: hasNoMarkers = !(markerCoordinates || progressLocations?.length > 0);
</script>

<!-- overflow-hidden required, because the map with cover the round corners otherwise -->
<div aria-label="map" class="relative w-full h-full rounded-lg overflow-hidden">
  {#if hasNoMarkers}
    <div class="absolute top-0 left-0 w-full h-full z-5 flex items-center justify-center">
      {mapOverlayCopy}
    </div>
  {/if}
  <div class="w-full h-full min-h-80" class:blur-sm={hasNoMarkers} bind:this={container}></div>
</div>
